<template>
    <div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("nationality.nameKh")
                }}</label>
                <input
                    v-model.trim="model.nationality_name_kh"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('nationality_name_kh') }"
                    ref="nationality_name_kh"
                />
                <div
                    class="invalid-feedback"
                    v-if="errors.has('nationality_name_kh')"
                >
                    {{ errors.first("nationality_name_kh") }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t("nationality.nameEn")
                }}</label>
                <input
                    v-model.trim="model.nationality_name_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('nationality_name_en') }"
                />
                <div
                    class="invalid-feedback"
                    v-if="errors.has('nationality_name_en')"
                >
                    {{ errors.first("nationality_name_en") }}
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
                <ts-button
                    @click.prevent="() => $emit('cancel')"
                    class="btn-gray"
                >
                    {{ $t("cancel") }}</ts-button
                >
                <ts-button
                    v-if="!isUpdate"
                    color="primary"
                    outline
                    :waiting="waiting_new"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSaveAddNew"
                >
                    {{ $t("saveAddNew") }}</ts-button
                >
                <ts-button
                    color="primary"
                    v-if="!isUpdate"
                    :waiting="waiting"
                    :disabled="waiting_new || waiting"
                    @click.prevent="onSave"
                >
                    {{ $t("save") }}</ts-button
                >
                <ts-button
                    v-if="isUpdate"
                    color="primary"
                    @click.prevent="onUpdate"
                    :waiting="waiting"
                >
                    {{ $t("update") }}</ts-button
                >
            </div>
        </div>
        <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
import { isEmpty } from "lodash";

export default {
    name: "nationalityForm",
    data() {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            waiting_new: false,
            model: {
                nationality_name_kh: null,
                nationality_name_en: null
            }
        };
    },
    computed: {
        ...mapState("humanResource/nationality", ["edit_data"]),
        isUpdate() {
            return !isEmpty(this.edit_data);
        }
    },
    methods: {
        async onSaveAddNew() {
            this.errors = new Errors();
            this.waiting_new = true;
            this.$store
                .dispatch("humanResource/nationality/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("fetchData");
                    this.clearInput();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting_new = false;
                });
        },
        async onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("humanResource/nationality/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        onUpdate() {
            this.waiting = true;
            this.$store
                .dispatch("humanResource/nationality/update", {
                    id: this.edit_data.nationality_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    this.$emit("cancel");
                    this.$emit("fetchData");
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        setEditData() {
            this.$nextTick(function() {
                this.$refs.nationality_name_kh.focus();
            });
            if (!isEmpty(this.edit_data)) {
                this.model.nationality_name_kh = this.edit_data.nationality_name_kh;
                this.model.nationality_name_en = this.edit_data.nationality_name_en;
            }
        },
        clearInput() {
            this.errors = new Errors();
            this.model.nationality_name_kh = null;
            this.model.nationality_name_en = null;
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "NATIONALITY",
                desc: not.text
            });
        }
    }
};
</script>
